import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LocalizationModule } from 'angular-l10n';
import { MaterialModule } from '../../common/material.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { TreeDiagram } from '../angular2-tree-diagram';
import {AppProgressBar } from './app-progress-bar.component';



@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    LocalizationModule,
    HttpClientModule,
    MaterialModule,
    BsDropdownModule,
    ChartsModule,
    TreeDiagram
    
  ],
  declarations: [AppProgressBar],
  providers: [],
  exports:[AppProgressBar]
})

export class AppProgressBarModule { }


// WEBPACK FOOTER //
// ./src/app/components/app-progress-bar/app-progress-bar.module.ts